import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "auth-container" }
const _hoisted_3 = { class: "auth-card" }
const _hoisted_4 = { class: "form-options" }
const _hoisted_5 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_6 = { class: "auth-footer" }

import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import type { FormInstance, FormRules } from 'element-plus';
import { ElMessage } from 'element-plus';
import { Lock, User } from '@element-plus/icons-vue';
import { useAuthStore } from '@/stores/auth';
import type { LoginCredentials } from '@/types/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const loginFormRef = ref<FormInstance>();

const loginForm = reactive({
  usernameOrEmail: '',
  password: '',
  rememberMe: false,
});

const loginRules: FormRules = {
  usernameOrEmail: [
    {
      required: true,
      message: 'Username or email is required',
      trigger: 'blur',
    },
    { min: 3, message: 'Must be at least 3 characters', trigger: 'blur' },
  ],
  password: [
    { required: true, message: 'Password is required', trigger: 'blur' },
    {
      min: 8,
      message: 'Password must be at least 8 characters',
      trigger: 'blur',
    },
  ],
};

const handleLogin = async () => {
  if (!loginFormRef.value) {
    return;
  }

  try {
    await loginFormRef.value.validate();

    const credentials: LoginCredentials = {
      usernameOrEmail: loginForm.usernameOrEmail.trim(),
      password: loginForm.password,
    };

    const success = await authStore.login(credentials);

    if (success) {
      // Redirect to home or intended route
      const redirectTo =
        (router.currentRoute.value.query.redirect as string) || '/';
      router.push(redirectTo);
    }
  } catch (error) {
    console.error('Login validation failed:', error);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "auth-header" }, [
          _createElementVNode("h1", null, "Welcome Back"),
          _createElementVNode("p", null, "Sign in to your Recipe Vault account")
        ], -1)),
        _createVNode(_component_el_form, {
          ref_key: "loginFormRef",
          ref: loginFormRef,
          model: loginForm,
          rules: loginRules,
          class: "auth-form",
          size: "large",
          onSubmit: _withModifiers(handleLogin, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "usernameOrEmail" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.usernameOrEmail,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.usernameOrEmail) = $event)),
                  placeholder: "Username or Email",
                  "prefix-icon": "User",
                  disabled: _unref(authStore).isAuthenticating
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
                  type: "password",
                  placeholder: "Password",
                  "prefix-icon": "Lock",
                  "show-password": "",
                  disabled: _unref(authStore).isAuthenticating,
                  onKeyup: _withKeys(handleLogin, ["enter"])
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: loginForm.rememberMe,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.rememberMe) = $event)),
                    disabled: _unref(authStore).isAuthenticating
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" Remember me ")
                    ])),
                    _: 1,
                    __: [3]
                  }, 8, ["modelValue", "disabled"]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "forgot-link" }, "Forgot password?", -1))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "custom-button auth-submit-btn",
                  loading: _unref(authStore).isAuthenticating,
                  onClick: handleLogin
                }, {
                  default: _withCtx(() => [
                    (!_unref(authStore).isAuthenticating)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createVNode(_unref(Lock), { class: "button-icon" })
                        ]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_unref(authStore).isAuthenticating ? 'Signing In...' : 'Sign In'), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _cache[6] || (_cache[6] = _createTextVNode(" Don't have an account? ")),
            _createVNode(_component_router_link, {
              to: "/register",
              class: "auth-link"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Sign up here")
              ])),
              _: 1,
              __: [5]
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})